// Shared palette for readiness / progress bars. Both the chat-home stat cards
// (multi-segment role bars) and the dashboard readiness hero (single threshold
// bar + donut) read from the SAME getReadiness engine, so they must look the
// same too — one source of truth for the colors keeps them in lockstep.
//
// These are brighter than the house StatCard *text* palette: a thin decorative
// bar can carry more saturation than body text without hurting legibility. Kept
// professional (Tailwind 500/600 family + brand blue), not neon.
export const PROGRESS_COLORS = {
  green: 'var(--status-green)', // success / high score / approved
  amber: 'var(--status-orange)', // warning / mid score
  red: '#DC2626', // critical / low score
  blue: '#3F5FCE', // in-progress (brand)
  // Not-applicable: settled, but not an achievement. Reads as "accounted for"
  // next to green/blue while staying clearly distinct from the empty track.
  neutral: '#B9B9B4',
  track: '#ECECEA', // unfilled remainder
} as const

/**
 * Threshold → hex for a single-bar score color (dashboard CoverageBar + donut).
 * ≥80 green, ≥50 amber, otherwise red.
 */
export function scoreHex(pct: number): string {
  if (pct >= 80) return PROGRESS_COLORS.green
  if (pct >= 50) return PROGRESS_COLORS.amber
  return PROGRESS_COLORS.red
}
